(function(){
  const header = document.querySelector('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 4);
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

  const btn = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (btn && nav) {
    const close = () => {
      nav.removeAttribute('data-open'); nav.setAttribute('hidden','');
      btn.setAttribute('aria-expanded','false'); document.body.classList.remove('mnav-open');
    };
    const open = () => {
      nav.setAttribute('data-open',''); nav.removeAttribute('hidden');
      btn.setAttribute('aria-expanded','true'); document.body.classList.add('mnav-open');
    };
    btn.addEventListener('click', () => nav.hasAttribute('data-open') ? close() : open());
    nav.querySelector('[data-menu-close]')?.addEventListener('click', close);
  }

  /* [data-reveal] starts at translateY(26px), so the browser computes an in-page
     scroll target from the translated position and the reveal then shifts it
     26px out from under the sticky header. Settle the target first, with no
     transition — this is where the reader is jumping to, not something to
     animate into place. */
  const settleTarget = (hash) => {
    if (!hash || hash.length < 2) return;
    let el = null;
    try { el = document.querySelector(hash); } catch (e) { return; }
    if (!el || el.classList.contains('is-in')) return;
    el.style.transition = 'none';
    el.classList.add('is-in');
    void el.offsetHeight;
    requestAnimationFrame(() => { el.style.transition = ''; });
  };
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', () => settleTarget(a.getAttribute('href')));
  });
  settleTarget(location.hash);

  document.querySelectorAll('[data-qty]').forEach(root => {
    const input = root.querySelector('input');
    root.querySelector('[data-qty-dec]').addEventListener('click', () => { input.value = Math.max(1, (+input.value||1) - 1); });
    root.querySelector('[data-qty-inc]').addEventListener('click', () => { input.value = (+input.value||1) + 1; });
  });

  document.querySelectorAll('[data-pdp-thumbs] button').forEach(b => {
    b.addEventListener('click', () => {
      const src = b.dataset.src;
      const hero = document.querySelector('[data-pdp-hero] img');
      if (hero && src) hero.src = src;
      document.querySelectorAll('[data-pdp-thumbs] button').forEach(x => x.classList.remove('is-active'));
      b.classList.add('is-active');
    });
  });

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-in'));
  }

  // Subtle parallax on hero watermark
  const wm = document.querySelector('.hero-watermark');
  if (wm && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < 1200) wm.style.transform = `translate(-50%,-50%) rotate(-3deg) translateY(${y * 0.12}px)`;
    }, { passive: true });
  }
})();
